import { getOperatorUiBuildInfo } from "./buildInfo";
import type { OperatorUiBuildInfo } from "./buildInfo";

/** Log build identity to console and expose `globalThis.__OPERATOR_UI__`. */
export function logOperatorUiBuildInfo(): OperatorUiBuildInfo {
  const info = getOperatorUiBuildInfo();
  if (typeof globalThis !== "undefined") {
    (globalThis as Record<string, unknown>).__OPERATOR_UI__ = info;
  }

  const label = info.label;
  console.info(
    `%c operator-ui %c ${label} `,
    "background:#2563eb;color:#fff;padding:2px 6px;border-radius:3px 0 0 3px;font-weight:600",
    "background:#1e293b;color:#e2e8f0;padding:2px 6px;border-radius:0 3px 3px 0;font-family:monospace"
  );
  console.info("[build]", info);
  return info;
}
